import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import CommunityPolicingDetails from '../../subdepartmentdetails/CommunityPolicing'


function CommunityPolicing() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Community Policing and Crime Prevention || Public Safety";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Public Safety"
            title="Community Policing"
            subtitledown="Department of Public Safety"
           />
            <CommunityPolicingDetails/>
        </div>
    </>
  )
}

export default CommunityPolicing